/*------------------------------------*\
    Get Educated tabs
\*------------------------------------*/

module.exports = function(){

    function openTab(){

        setTimeout(function(){

            var windowHash = location.hash.split('#')[1];
            var $currentTab = $('.js-get-educated-tab[data-tab="' + windowHash + '"]');
            var $currentTabHash = $('.js-get-educated-tab-trigger[href*="#' + windowHash + '"]');

            $('.js-get-educated-tab').removeClass('is-current');
            $currentTab.addClass('is-current');

            $('.js-get-educated-tab-trigger').removeClass('is-current');
            $currentTabHash.addClass('is-current');

            $currentTab.trigger('tabopen');

        }, 1);

    }


    $('.js-get-educated-tab-trigger').on('click', function() {
        openTab();
    });


}; // end of module.exports


// WEBPACK FOOTER //
// ./js-source/blocks/get-educated.js